// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oTV2","badges":"styles_badges__2T-Ye"};